import {
  axiosInstance,
  getConfiguration,
  Team,
  TeamRole,
} from '@foxtrotplatform/platform-micro-site-core';
import { AxiosRequestConfig } from 'axios';

import { DeveloperAppConfig } from '../../common/config/developerAppConfig';
import { TeamType } from '../enums';
import { DeveloperOrganization } from '../providers/types';
import { ApiResponse } from './types';

export const getEmailDomainOrg = async (): Promise<DeveloperOrganization> => {
  const config = (await getConfiguration()) as DeveloperAppConfig;
  const request: AxiosRequestConfig = {
    url: `${config.baseApiUrl}/organization/domain`,
    method: 'get',
  };
  const { data }: ApiResponse<DeveloperOrganization> = await axiosInstance(
    request
  );

  return data;
};

export const getUserOrgs = async (): Promise<DeveloperOrganization[]> => {
  const config = (await getConfiguration()) as DeveloperAppConfig;
  const request: AxiosRequestConfig = {
    url: `${config.baseApiUrl}/organization/`,
    method: 'get',
  };
  const response: ApiResponse<DeveloperOrganization[]> = await axiosInstance(
    request
  );

  return response.data;
};

export const getUserDeveloperTeams = async (orgId: string): Promise<Team[]> => {
  const config = (await getConfiguration()) as DeveloperAppConfig;
  const request: AxiosRequestConfig = {
    url: `${config.baseApiUrl}/organization/${orgId}/team`,
    method: 'get',
  };
  const response: ApiResponse<any> = await axiosInstance(request);

  const teams: Team[] = response.data
    .filter(
      (x: any) =>
        x.teamInstance !== TeamType.organization &&
        x.teamInstance !== TeamType.organizationMembers
    )
    .map((x: { teamId: string; teamName: string; orgId: string }) => {
      return {
        id: x.teamId,
        name: x.teamName,
        orgId: x.orgId,
      } as Team;
    });

  return teams;
};

export const getUserTeamInfo = async (orgId: string): Promise<TeamMember[]> => {
  const config = (await getConfiguration()) as DeveloperAppConfig;
  const request: AxiosRequestConfig = {
    url: `${config.baseApiUrl}/organization/${orgId}/membership/self`,
    method: 'get',
  };
  const response: ApiResponse<any> = await axiosInstance(request);

  return response.data.map(
    (x: {
      teamId: string;
      emailId: string;
      userRoleId: TeamRole;
      userFullName: string;
    }) => {
      return {
        id: x.teamId,
        email: x.emailId,
        role: x.userRoleId,
        userRole: x.userRoleId,
        fullName: x.userFullName,
      };
    }
  );
};

export const getPendingUserInviations = async (): Promise<Invitation[]> => {
  const config = (await getConfiguration()) as DeveloperAppConfig;
  const request: AxiosRequestConfig = {
    url: `${config.baseApiUrl}/organization/invitations/self`,
    method: 'get',
  };
  const response: ApiResponse<any> = await axiosInstance(request);

  return response.data.map(({ id, orgId, teamId, teamName, emailId }: any) => {
    return {
      id: id,
      orgId: orgId,
      teamId: teamId,
      teamName: teamName,
      requestedEmail: emailId,
    };
  });
};
